import initTracing from './tracing';
import initLogging from './logging';

export default function initTelemetry() {
  initTracing();
  initLogging();
}
